module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_school_green-32c8d35e4bf352ebc1577000da9764ea.svg";